import { useContext } from 'react';
import GoalContext from 'src/careflow/care-coordination/case/goal/provider/context';

const useGoalContext = () => {
  const goalContext = useContext(GoalContext);
  return goalContext;
};

export default useGoalContext;
